import isString from 'lodash/isString'

export const getFileTypeFromName = (fileName?: string) => {
  if (fileName && isString(fileName)) {
    const fileType = fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2)
    return fileType || null
  }
  return null
}

export const fileNameHasNotAllowedTypes = (
  notAllovedTypes: Array<string>,
  fileName?: string
) => {
  const fileType = getFileTypeFromName(fileName)

  if (fileType) {
    return fileTypeNotAllowed(notAllovedTypes, fileType)
  }
}

export const fileTypeNotAllowed = (
  notAllovedTypes: Array<string>,
  fileType?: string
) => (fileType ? notAllovedTypes.includes(fileType.toLocaleLowerCase()) : false)
